import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Picture from '../components/Picture'
import { getWidth } from './utils'

const ProjectTitle = styled.h1`
	font-family: Roboto;
	font-size: 40px;
	font-weight: 500;
	margin: 15vh 0 0 15vw;

	@media (max-width: 480px){
		font-size: 35px;
		margin 5vh 0 2vh 0;
		text-align: center;
	}
`

const ProjectText = styled.p`
	font-family: Roboto;
	font-size: 20px;
	font-weight: 300;
	line-height: 1.5;
	margin: 2vh 0 5vh 17vw;
	width: 65vw;
	white-space: pre-wrap;

	@media (max-width: 480px){
		font-size: 16px;
		width: 80vw;
		margin: 0 10vw 5vh 10vw;
		text-align: center;
	}
`

const ImagesWrapper = styled.div`
	display: ${props => props.layout === 'dreier' || props.layout === 'zweier' ? 'flex' : 'block'};
	flex-wrap: ${props => props.layout === 'dreier' || props.layout === 'zweier' ? 'wrap' : 'initial'};
	width: ${props => getWidth(props.layout)}vw;
	justify-content: ${props => props.layout === 'dreier' ? 'space-between' : 'initial'};
	margin: auto;

	@media (max-width: 480px){
		width: 95vw;
	}
`

const ProjectImage = styled.div`
	flex-basis: ${props => {
		if (props.layout === 'dreier') {
			return '30%'
		} else if (props.orientation === 'portrait' && props.layout === 'zweier') {
			return '47%'
		} else if (props.orientation === 'landscape' && props.layout === 'zweier') {
			return '100%'
		}
	}};

	min-width: ${props => !(props.layout === 'dreier') && '300px'};
    flex-grow: 1;
    margin: 1%;
	display: flex;
	flex-directiom: column;
	justify-content: center;
`

export default class ProjectPage extends React.Component{
	render(){
		let sizes = "90vw"

		if (this.props.layout === 'dreier') {
			sizes = "27vw"
		} else if (this.props.orientation === 'portrait' && this.props.layout === 'zweier') {
			sizes = "(max-width: 740px) 90vw, 44vw"
		} else if (this.props.orientation === 'landscape' && this.props.layout === 'zweier') {
			sizes = "90vw"
		}

		return(
			<div>
				<ProjectTitle>{this.props.title}</ProjectTitle>
				<ProjectText>{this.props.text}</ProjectText>
				<ImagesWrapper layout={this.props.layout}>
					{this.props.images.map(projectImage => (
						<ProjectImage key={projectImage.src} orientation={projectImage.orientation} layout={this.props.layout}>
							<Picture sizes={sizes} imagecode={projectImage.src} orientation={projectImage.orientation} layout={this.props.layout} size="project"/>
						</ProjectImage>
					))}
				</ImagesWrapper>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/ProjectPage.js